"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatorTypes = exports.componentTypes = void 0;
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const react_form_renderer_1 = require("@data-driven-forms/react-form-renderer");
const validator_types_1 = __importDefault(require("@data-driven-forms/react-form-renderer/validator-types"));
exports.validatorTypes = validator_types_1.default;
const Checkbox_1 = __importDefault(require("./components/Checkbox"));
const Custom_1 = __importDefault(require("./components/Custom"));
const Datepicker_1 = __importDefault(require("./components/Datepicker"));
const ExpandableSection_1 = __importDefault(require("./components/ExpandableSection"));
const FieldArray_1 = __importDefault(require("./components/FieldArray"));
const FormTemplate_1 = __importDefault(require("./components/FormTemplate"));
const Radio_1 = __importDefault(require("./components/Radio"));
const Review_1 = __importDefault(require("./components/Review"));
const Select_1 = __importDefault(require("./components/Select"));
const Subform_1 = __importDefault(require("./components/Subform"));
const Switch_1 = __importDefault(require("./components/Switch"));
const Table_1 = __importDefault(require("./components/Table"));
const Textarea_1 = __importDefault(require("./components/Textarea"));
const TextField_1 = __importDefault(require("./components/TextField"));
const TimePicker_1 = __importDefault(require("./components/TimePicker"));
const TreeView_1 = __importDefault(require("./components/TreeView"));
const Wizard_1 = __importDefault(require("./components/Wizard"));
const MarkdownEditor_1 = __importDefault(require("./components/MarkdownEditor"));
const types_1 = require("./types");
Object.defineProperty(exports, "componentTypes", { enumerable: true, get: function () { return types_1.componentTypes; } });
const componentMapper = {
    [types_1.componentTypes.TEXT_FIELD]: TextField_1.default,
    [types_1.componentTypes.CHECKBOX]: Checkbox_1.default,
    [types_1.componentTypes.SUB_FORM]: Subform_1.default,
    [types_1.componentTypes.RADIO]: Radio_1.default,
    [types_1.componentTypes.DATE_PICKER]: Datepicker_1.default,
    [types_1.componentTypes.TIME_PICKER]: TimePicker_1.default,
    [types_1.componentTypes.SWITCH]: Switch_1.default,
    [types_1.componentTypes.TEXTAREA]: Textarea_1.default,
    [types_1.componentTypes.SELECT]: Select_1.default,
    [types_1.componentTypes.WIZARD]: Wizard_1.default,
    [types_1.componentTypes.FIELD_ARRAY]: FieldArray_1.default,
    [types_1.componentTypes.TREE_VIEW]: TreeView_1.default,
    [types_1.componentTypes.EXPANDABLE_SECTION]: ExpandableSection_1.default,
    [types_1.componentTypes.TABLE]: Table_1.default,
    [types_1.componentTypes.REVIEW]: Review_1.default,
    [types_1.componentTypes.CUSTOM]: Custom_1.default,
    [types_1.componentTypes.MARKDOWN_EDITOR]: MarkdownEditor_1.default,
};
/**
 * FormRenderer converts JSON form definitions into fully functional React forms.
 *
 * It leverages [Data Driven Form](https://data-driven-forms.org/) with customer component mappings to use our own form controls.
 */
const FormRenderer = ({ schema, validatorMapper, onSubmit, onCancel, isSubmitting, initialValues, subscription, customComponentWrapper, }) => {
    const WrappedFormTemplate = react_1.useMemo(() => (props) => react_1.default.createElement(FormTemplate_1.default, Object.assign({ isSubmitting: isSubmitting }, props)), [isSubmitting]);
    return (react_1.default.createElement(react_form_renderer_1.FormRenderer, { componentMapper: Object.assign(Object.assign({}, componentMapper), customComponentWrapper), FormTemplate: WrappedFormTemplate, validatorMapper: validatorMapper, schema: schema, onSubmit: onSubmit, onCancel: onCancel, subscription: subscription, initialValues: initialValues }));
};
exports.default = FormRenderer;
//# sourceMappingURL=index.js.map